/* eslint-disable */
export default {
  authServiceUrl: process.env.AUTHENTICATION_SERVICE_URL,
  benefitsDataServiceURL: process.env.BENEFITS_DATA_SERVICE_URL,
  masterDataServiceURL: process.env.MASTER_DATA_SERVICE_URL,
  masterDataUIURL: process.env.MASTER_DATA_UI_URL,
  masterDataReportsURL: process.env.MASTER_DATA_REPORTS,
  partnerURL: process.env.PARTNER_URL,
  publicPath: process.env.PUBLIC_PATH,
  scheduleURL: process.env.SCHEDULE_URL,
  timeLaborURL: process.env.TIME_LABOR_URL,
  timeLaborDailyURL: process.env.TIME_LABOR_DAILY_URL,
  timeuiURL: process.env.EMBED_TIMEUI_URL,
  partnerIntegrationEmbedURL: process.env.PARTNER_INTEGRATION_EMBED_URL,
  geofenceManagementURL: process.env.GEOFENCE_MANAGEMENT_EMBED_URL,
  hubComponentsEmbedUrl: process.env.HUB_COMPONENTS_EMBED_URL,
  devToken: process.env.DEV_TOKEN,
  hubSSOUrl: process.env.HUB_SSO_URL,
  wfhUiUrl: process.env.WFHUI_URL,
  wfhApiUrl: process.env.WFHAPI_URL,
  appEnv: process.env.APP_ENV,
  amplitudeWFHApiKey: process.env.AMPLITUDE_WFH_API_KEY,
  isDeployedBuild: process.env.IS_DEPLOYED_BUILD,
  billingServiceUrl: process.env.BILLING_SERVICE_EXTERNAL_URL,
  webclockEmbedURL: process.env.WEBCLOCK_EMBED_URL,
  essUIUrl: process.env.ESSUI_URL,
};
